export default {
  init($element) {

  },
  finalize($element) {
    $(window).on('scroll', function() {
      if (($(window).scrollTop() + ($(window).innerHeight() / 2)) >= $element.offset().top) {
        $element.find('.lottie-home-solutions').each(function() {
          $(this).trigger('lottie-play');
        });
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/ourSolutions.js